(function () {
	'use strict';

	// A card is scanned, not read: the date only earns colour once it is close
	// enough to act on. The seven months this card used to warn at covered most
	// of a project's life, so nearly every card carried a warning.
	var DEFAULT_TAG_COLOR = '#dbf5d1';

	var EXPIRATION_ALERT_THRESHOLD = moment.duration(7, 'd');
	var EXPIRATION_WARNING_THRESHOLD = moment.duration(1, 'M');

	// '' only when there is no date to judge: a project with no expiry has nothing
	// to say here, which is not the same as one comfortably clear of its own.
	function expirationLevel(project) {
		if (project.expired) {
			return 'expired';
		}
		if (!project.expiration_date) {
			return '';
		}
		var remaining = moment.duration(project.expiration_date - Date.now());
		if (remaining < EXPIRATION_ALERT_THRESHOLD) {
			return 'alert';
		}
		if (remaining < EXPIRATION_WARNING_THRESHOLD) {
			return 'warning';
		}
		return 'ok';
	}

	// Two letters is what fits the circle: one per name where there are two,
	// otherwise the first two of whatever single word the user goes by.
	function initials(name) {
		if (!name) {
			return '';
		}
		var parts = String(name).trim().split(/\s+/);
		if (parts.length > 1 && parts[1]) {
			return (parts[0].charAt(0) + parts[1].charAt(0)).toUpperCase();
		}
		return parts[0].substring(0, 2).toUpperCase();
	}

	function applyTagLabelColors(tags) {
		_.each(tags || [], function (tag) {
			if (tag) {
				tag.labelColor = tagLabelColor(tag.color || DEFAULT_TAG_COLOR);
			}
		});
	}

	angular.module('dcApp').directive('projectCard', [
		'$parse',
		function ($parse) {
			var controller = [
				'$scope',
				'$rootScope',
				'$state',
				'gettextCatalog',
				'ModalService',
				'API_BASE_URL_BACKEND',
				'ProjectService',
				'AppSelectorService',
				'UserService',
				function (
					$scope,
					$rootScope,
					$state,
					gettextCatalog,
					ModalService,
					API_BASE_URL_BACKEND,
					ProjectService,
					AppSelectorService,
					UserService
				) {
					var vm = this;

					$scope.API_BASE_URL_BACKEND = API_BASE_URL_BACKEND;
					$scope.currentDate = moment(new Date()).format('LLLL');
					// An object, not a plain variable: the tooltip sits under an ng-if and
					// the widget writes its visibility back on the scope it was created
					// in, the child one. A plain variable would be shadowed there the first
					// time the tooltip closes itself, and it would never open again.
					$scope.membersState = { visible: false };
					// The members tooltip is a dxTooltip, and building one costs
					// about as much as the rest of the card put together. Almost no
					// card is ever asked for its members, so it is built on the
					// first ask and kept from then on.
					$scope.membersTooltipBuilt = false;

					vm.init = function (data) {
						vm.expirationLevel = expirationLevel(data);

						applyTagLabelColors(data.metadata ? data.metadata.tags : null);
						applyTagLabelColors(data.grouping_tags);

						// The strip is one line and the codes are elided; the row's
						// tooltip is where the full set stays readable.
						vm.groupingTagCodes = _.map(
							data.grouping_tags || [],
							function (tag) {
								return tag.code;
							}
						).join(', ');

						vm.tooltipOptions = {
							target: '#members' + data.id,
							bindingOptions: {
								visible: 'membersState.visible',
							},
						};

						vm.metadataInfo = {
							id: data.id,
							code: data.metadata.code,
							updateDate: data.metadata.update_date,
							creationDate: data.metadata.creation_date,
							createdBy: data.metadata.created_by,
							updatedBy: data.metadata.updated_by,
							metadataId: data.metadata.id,
						};
					};

					// The list controller fills last_access_by from its own request,
					// which lands after init(): watch rather than read it once. This
					// replaces the <user-info> element that used to make the same call.
					$scope.$watch(
						function () {
							return vm.data ? vm.data.last_access_by : null;
						},
						function (userId) {
							vm.lastAccessName = '';
							vm.lastAccessInitials = '';
							if (!userId) {
								return;
							}
							// Cards share their last-accessor far more often than not,
							// and every relayout asks again: one request per id for
							// the whole page rather than one per card.
							UserService.getUserBasicCached(userId).then(function (response) {
								vm.lastAccessName = response.data.name;
								vm.lastAccessInitials = initials(response.data.name);
							});
						}
					);

					// The last access is the timestamp the server sent. Its two texts are
					// worded once, when it arrives, not on every digest of a page that has
					// many of them. Only the relative one moves with the clock, so the card
					// watches the current minute, which costs a clock read and a division.
					function accessDate(value) {
						if (!value) {
							return null;
						}
						var date = moment(value).startOf('minute');
						return date.isValid() ? date : null;
					}

					function relativeAccess(value) {
						var date = accessDate(value);
						return date
							? moment.duration(date - moment().startOf('minute')).humanize(true)
							: '';
					}

					function exactAccess(value) {
						var date = accessDate(value);
						return date ? date.format('DD/MM/YYYY HH:mm') : '';
					}

					vm.lastAccessRelative = '';
					vm.lastAccessExact = '';

					$scope.$watch(
						function () {
							return vm.data ? vm.data.last_access_date : null;
						},
						function (value) {
							vm.lastAccessRelative = relativeAccess(value);
							vm.lastAccessExact = exactAccess(value);
						}
					);

					$scope.$watch(
						function () {
							return Math.floor(Date.now() / 60000);
						},
						function (minute, previous) {
							if (minute !== previous) {
								vm.lastAccessRelative = relativeAccess(
									vm.data ? vm.data.last_access_date : null
								);
							}
						}
					);

					$scope.adminProjectMembers = [];

					$scope.setDefault = function () {
						if (vm.data.inactive) {
							return;
						}
						vm.data.default_project = !vm.data.default_project;
						AppSelectorService.setSelectedProject(
							vm.data.id,
							vm.data.metadata.label,
							vm.data.version,
							vm.data.is_default_version,
							vm.data.version_count
						);
						ProjectService.setDefaultProject(
							vm.data.id,
							vm.data.default_project
						).then(function (response) {
							$scope.vm.afterSetDefault(vm.data.id, vm.data.default_project);
						});
					};

					$scope.setFavorite = function () {
						if (vm.data.inactive) {
							return;
						}
						vm.data.favorite_project = !vm.data.favorite_project;
						ProjectService.setFavoriteProject(
							vm.data.id,
							vm.data.favorite_project
						).then(function (response) {
							if (vm.afterSetFavorite) {
								vm.afterSetFavorite(vm.data.id, vm.data.favorite_project);
							}
						});
					};

					$scope.showProjectMembers = function ($event) {
						// The icon of this card, read now: the event is gone when the
						// members arrive. A project that carries several tags is rendered
						// under each of them, so '#members<id>' exists once per copy and
						// would resolve to the first one on the page.
						var icon =
							$event &&
							$event.currentTarget &&
							$event.currentTarget.querySelector('.project-card__members-icon');
						ProjectService.getMembersByProjectId(vm.data.id).then(function (
							data
						) {
							$scope.adminProjectMembers = data.filter(
								(member) => member.admin
							);
							if (icon) {
								vm.tooltipOptions.target = icon;
							}
							// Set before the flag the widget binds its visibility to,
							// so the tooltip this digest creates already reads as
							// open rather than needing a second pass to show.
							$scope.membersTooltipBuilt = true;
							$scope.membersState.visible = true;
						});
					};

					$scope.showMailForm = function (member) {
						$scope.vm.sendMailData.projectId = vm.data.id;
						$scope.vm.sendMailData.member = member;
						$scope.membersState.visible = false;
						$scope.vm.sendMailData.showSendMailModal = true;
					};

					$scope.goIn = function () {
						$rootScope.$broadcast('update:menu:selection', true); // TODO: remove
						$state.go('gd-home', { projectId: vm.data.id });
					};

					$scope.editProject = function () {
						$state.go('projects-edit', { projectId: vm.data.id });
					};

					$scope.deleteProject = function (e) {
						e.stopPropagation();
						e.preventDefault();
						if (vm.data.version_count > 1) {
							ModalService.info({
								title: gettextCatalog.getString('Suppression du projet'),
								content: gettextCatalog.getString(
									'project.delete.many.versions.error'
								),
								acceptLabel: gettextCatalog.getString('modal.cancel.label'),
							}).then();

							return;
						}
						var deleteProjectModalParams = {
							moduleName: 'deleteProject',
							modalName: 'deleteProject',
							controllerName: 'DeleteProjectController',
							dependencies: {
								title:
									gettextCatalog.getString('Suppression du projet') +
									':' +
									' ' +
									vm.data.metadata.label,
								projectId: vm.data.id,
								projectName: vm.data.metadata.label,
							},
						};
						openModal(deleteProjectModalParams);
					};

					$scope.duplicateProject = function () {
						alert('Not yet available');
					};

					$scope.importProjectVersion = function (version) {
						$rootScope.$broadcast('import_project_new_version', version);
					};

					function openModal(modalParams) {
						if (!modalParams.modalName || !modalParams.controllerName) {
							return;
						}
						ModalService.open({
							controllerAs: 'vm',
							bindToController: true,
							templateUrl:
								'./src/components/modules/project/' +
								modalParams.moduleName +
								'/' +
								modalParams.modalName +
								'.html',
							controller: modalParams.controllerName,
							disableBackdrop: true,
							locals: modalParams.dependencies
								? modalParams.dependencies
								: undefined,
						});
					}
				},
			];

			return {
				restrict: 'E',

				scope: {
					data: '=',
					selectedProjectId: '=',
					afterSetDefault: '=',
					afterSetFavorite: '=',
					deleteAction: '=',
					selectionEnabled: '=',
					memberEnabled: '=',
					sendMailData: '=',
					isNew: '=',
					config: '=',
				},
				controller: controller,
				controllerAs: 'vm',
				bindToController: true,
				templateUrl:
					'./src/components/directives/project/projectCard/projectCard.html',
				transclude: true,
				replace: true,
				link: function postLink($scope, element, attrs, $ctrl) {
					$scope.$watch(
						function () {
							return $ctrl.data.id;
						},
						function (newVal) {
							$ctrl.init($ctrl.data);
						}
					);

					// Ids reach this card as both strings and numbers depending on
					// where they came from, so compare the numbers. -1 is what the
					// selector reports when nothing is selected: it matches no card.
					$scope.$watch(
						function () {
							return $ctrl.selectedProjectId;
						},
						function (selectedId) {
							$ctrl.isCurrent =
								selectedId !== null &&
								selectedId !== undefined &&
								Number(selectedId) === Number($ctrl.data.id);
						}
					);
				},
			};
		},
	]);
})();
